import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faCopy } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { apiService } from '../../services/apiService';
import './communityMemberView.css';

function ViewCommunityMember() {
    const navigate = useNavigate();
    const { userid } = useParams();
    const [loading, setLoading] = useState(true);
    const [userdatas, setDatas] = useState([]);
    useEffect(() => {
        const fetchCurrentData = async () => {
            try {
            const response = await apiService.getRequest(`/community-members/${userid}`);
            if (response.success && response.success === true) {
                setDatas(response.data);
            }
            } catch (error) {
                console.error("Error fetching onboarding data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCurrentData();
    }, [ userid ]);

    const copyToClipboard = (value, label) => {
        if (!value) return;
        navigator.clipboard.writeText(value);
        toast(`${label} copied to clipboard`);
    };

    const copyPageLink = () => {
        navigator.clipboard.writeText(window.location.href);
        toast('Page link copied to clipboard');
    };

  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center">
                    <Grid size={{xs:12}} container justifyContent="space-between">
                        <Grid container flexDirection="column" className="jobseekerhead">
                            <h3>Community Member</h3>
                            <span>
                                <b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                                <b onClick={()=>navigate("/community-member")}>Community Members</b>
                                {userdatas && userdatas.formatted_id &&
                                <>
                                    <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                                    <span className='cm_breadcrumb_id cursetespoint' title="Copy page link" onClick={() => copyPageLink()}>
                                        {userdatas.formatted_id}{userdatas.full_name ? ` - ${userdatas.full_name}` : ''}
                                    </span>
                                </>}
                            </span>
                        </Grid>
                        <Grid container flexDirection="column" className="jobseekerhead">
                            <button className='registersendbtn1 my-0' onClick={()=>navigate('/community-member')}>Back</button>
                        </Grid>
                    </Grid>
                    {loading ?
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :<>
                        <Grid size={{xs:12}} container className="mt-5 cm_view_card">
                            <Grid size={{sm:12,xs:12}} container>
                                <h5 className='cm_section_title'>Overview</h5>
                            </Grid>
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>ID Number</span>
                                <span className='cm_field_value_row'>
                                    <span className='blue_linkviewmember'>{userdatas.formatted_id || "-" }</span>
                                    {userdatas.formatted_id &&
                                    <button type="button" className='cm_copy_btn' title="Copy ID" onClick={() => copyToClipboard(userdatas.formatted_id, 'ID Number')}>
                                        <FontAwesomeIcon icon={faCopy} />
                                    </button>}
                                </span>
                            </Grid>
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Source</span>
                                {userdatas && userdatas.source && userdatas.source.map((sources,index)=>(
                                    <span key={index} className='black_linkviewmember'>{sources}</span>
                                ))}
                            </Grid>
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Name</span>
                                <span className='black_linkviewmember'>{userdatas.full_name || "-" }</span>
                            </Grid>
                            {userdatas && userdatas.referred_by && userdatas.referred_by.full_name && userdatas.referred_by.full_name.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Referred by</span>
                                <span className='fullblue_linkviewmember cursetespoint' onClick={() => window.open(`/community-member/view/${userdatas.referred_by && userdatas.referred_by.formatted_id}`, '_blank')}>{userdatas && userdatas.referred_by && userdatas.referred_by.full_name}</span>
                            </Grid>}

                            <Grid size={{sm:12,xs:12}} container>
                                <h5 className='cm_section_title'>Contact Information</h5>
                            </Grid>
                            {userdatas && userdatas.phone_number && userdatas.phone_number.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Primary Phone</span>
                                <span className='cm_field_value_row'>
                                    <span className='black_linkviewmember'>{userdatas.phone_number || "-" }</span>
                                    <button type="button" className='cm_copy_btn' title="Copy Primary Phone" onClick={() => copyToClipboard(userdatas.phone_number, 'Primary Phone')}>
                                        <FontAwesomeIcon icon={faCopy} />
                                    </button>
                                </span>
                            </Grid>}
                            {userdatas && userdatas.secondary_phone_number && userdatas.secondary_phone_number.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Secondary Phone</span>
                                <span className='cm_field_value_row'>
                                    <span className='black_linkviewmember'>{userdatas.secondary_phone_number || "-" }</span>
                                    <button type="button" className='cm_copy_btn' title="Copy Secondary Phone" onClick={() => copyToClipboard(userdatas.secondary_phone_number, 'Secondary Phone')}>
                                        <FontAwesomeIcon icon={faCopy} />
                                    </button>
                                </span>
                            </Grid>
                            }
                            {userdatas && userdatas.other_phone_number && userdatas.other_phone_number.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Other Phone</span>
                                <span className='cm_field_value_row'>
                                    <span className='black_linkviewmember'>{userdatas.other_phone_number || "-" }</span>
                                    <button type="button" className='cm_copy_btn' title="Copy Other Phone" onClick={() => copyToClipboard(userdatas.other_phone_number, 'Other Phone')}>
                                        <FontAwesomeIcon icon={faCopy} />
                                    </button>
                                </span>
                            </Grid>
                            }
                            {userdatas && userdatas.email && userdatas.email.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Primary Email</span>
                                <span className='cm_field_value_row'>
                                    <span className='black_linkviewmember'>{userdatas.email || "-" }</span>
                                    <button type="button" className='cm_copy_btn' title="Copy Primary Email" onClick={() => copyToClipboard(userdatas.email, 'Primary Email')}>
                                        <FontAwesomeIcon icon={faCopy} />
                                    </button>
                                </span>
                            </Grid>}
                            {userdatas && userdatas.secondary_email && userdatas.secondary_email.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Secondary Email</span>
                                <span className='cm_field_value_row'>
                                    <span className='black_linkviewmember'>{userdatas.secondary_email || "-" }</span>
                                    <button type="button" className='cm_copy_btn' title="Copy Secondary Email" onClick={() => copyToClipboard(userdatas.secondary_email, 'Secondary Email')}>
                                        <FontAwesomeIcon icon={faCopy} />
                                    </button>
                                </span>
                            </Grid>
                            }
                            {userdatas && userdatas.other_email && userdatas.other_email.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Other Email</span>
                                <span className='cm_field_value_row'>
                                    <span className='black_linkviewmember'>{userdatas.other_email || "-" }</span>
                                    <button type="button" className='cm_copy_btn' title="Copy Other Email" onClick={() => copyToClipboard(userdatas.other_email, 'Other Email')}>
                                        <FontAwesomeIcon icon={faCopy} />
                                    </button>
                                </span>
                            </Grid>
                            }

                            {(userdatas?.living_city?.name || userdatas?.living_state?.name || userdatas?.living_country?.name) &&
                            <Grid size={{sm:12,xs:12}} container>
                                <h5 className='cm_section_title'>Location</h5>
                            </Grid>}
                            {userdatas?.living_city?.name &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Living City</span>
                                <span className='black_linkviewmember'>{userdatas.living_city.name}</span>
                            </Grid>
                            }
                            {userdatas?.living_state?.name &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Living State</span>
                                <span className='black_linkviewmember'>{userdatas.living_state.name}</span>
                            </Grid>}
                            {userdatas?.living_country?.name &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Living Country</span>
                                <span className='black_linkviewmember'>{userdatas.living_country.name}</span>
                            </Grid>}

                            {((userdatas && userdatas.level && userdatas.level.length > 0) || (userdatas && userdatas.comments && userdatas.comments.length > 0)) &&
                            <Grid size={{sm:12,xs:12}} container>
                                <h5 className='cm_section_title'>Additional Details</h5>
                            </Grid>}
                            {userdatas && userdatas.level && userdatas.level.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Level</span>
                                <span className='black_linkviewmember'>{userdatas.level || "-" }</span>
                            </Grid>}
                            {userdatas && userdatas.comments && userdatas.comments.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                <span className='gray_viewmember'>Relationship with Referrer</span>
                                <span className='black_linkviewmember'>{userdatas.comments || "-" }</span>
                            </Grid>}

                            {userdatas && userdatas.accepted_professional_references && <>
                                <Grid size={{sm:12,xs:12}} container>
                                    <h5 className='cm_section_title'>Professional Information</h5>
                                </Grid>
                                <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                    <span className='gray_viewmember'>Accepted Professional References</span>
                                    <span className='black_linkviewmember'>{userdatas.accepted_professional_references}</span>
                                </Grid>
                            </>}
                            {userdatas && userdatas.accepted_professional_references === 'Yes' && <>
                                <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                    <span className='gray_viewmember'>Current Company Name</span>
                                    <span className='black_linkviewmember'>{userdatas.prof_current_company_name || "-" }</span>
                                </Grid>
                                <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                    <span className='gray_viewmember'>Contact Number</span>
                                    <span className='cm_field_value_row'>
                                        <span className='black_linkviewmember'>{userdatas.prof_contact_number || "-" }</span>
                                        {userdatas.prof_contact_number &&
                                        <button type="button" className='cm_copy_btn' title="Copy Contact Number" onClick={() => copyToClipboard(userdatas.prof_contact_number, 'Contact Number')}>
                                            <FontAwesomeIcon icon={faCopy} />
                                        </button>}
                                    </span>
                                </Grid>
                                <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                    <span className='gray_viewmember'>Personal Email</span>
                                    <span className='cm_field_value_row'>
                                        <span className='black_linkviewmember'>{userdatas.prof_personal_email || "-" }</span>
                                        {userdatas.prof_personal_email &&
                                        <button type="button" className='cm_copy_btn' title="Copy Personal Email" onClick={() => copyToClipboard(userdatas.prof_personal_email, 'Personal Email')}>
                                            <FontAwesomeIcon icon={faCopy} />
                                        </button>}
                                    </span>
                                </Grid>
                                <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                    <span className='gray_viewmember'>Work Email</span>
                                    <span className='cm_field_value_row'>
                                        <span className='black_linkviewmember'>{userdatas.prof_work_email || "-" }</span>
                                        {userdatas.prof_work_email &&
                                        <button type="button" className='cm_copy_btn' title="Copy Work Email" onClick={() => copyToClipboard(userdatas.prof_work_email, 'Work Email')}>
                                            <FontAwesomeIcon icon={faCopy} />
                                        </button>}
                                    </span>
                                </Grid>
                                <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                    <span className='gray_viewmember'>LinkedIn URL</span>
                                    {userdatas.prof_linkedin_url ?
                                    <span className='cm_field_value_row'>
                                        <a href={userdatas.prof_linkedin_url} target="_blank" rel="noopener noreferrer" className='cm_linkedin_link'>{userdatas.prof_linkedin_url}</a>
                                        <button type="button" className='cm_copy_btn' title="Copy LinkedIn URL" onClick={() => copyToClipboard(userdatas.prof_linkedin_url, 'LinkedIn URL')}>
                                            <FontAwesomeIcon icon={faCopy} />
                                        </button>
                                    </span>
                                    : <span className='black_linkviewmember'>-</span>}
                                </Grid>
                                <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3 cm_field_row">
                                    <span className='gray_viewmember'>Current Job Title</span>
                                    <span className='black_linkviewmember'>{userdatas.prof_current_job_title || "-" }</span>
                                </Grid>
                            </>}
                        </Grid>
                    </>}
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default ViewCommunityMember
